import { InjectionToken } from '@angular/core';
import { CwcInputDate } from '@cmx-web-components/angular';
import { Observable } from 'rxjs';

export type CxUiInputDateDateFormat = CwcInputDate['dateFormat'];
export const CX_INPUT_DATE_FORMAT_TOKEN = new InjectionToken<
  CxUiInputDateDateFormat | Observable<CxUiInputDateDateFormat>
>('Token for providing cwc-input-date [format] property');

export type CxUiInputDateLanguage = CwcInputDate['language'];
export const CX_INPUT_DATE_LANGUAGE_TOKEN = new InjectionToken<
  CxUiInputDateDateFormat | Observable<CxUiInputDateLanguage>
>('Token for providing cwc-input-date [language] property');

export type CxUiInputDateFirstDayOfWeek = CwcInputDate['firstDayOfWeek'];
export const CX_INPUT_DATE_FIRST_DAY_OF_WEEK_TOKEN = new InjectionToken<
  CxUiInputDateDateFormat | Observable<CxUiInputDateFirstDayOfWeek>
>('Token for providing cwc-input-date [firstDayOfWeek] property');

export type CxUiInputDateControlButtons = CwcInputDate['controlButtons'];
export const CX_INPUT_DATE_CONTROL_BUTTONS_TOKEN = new InjectionToken<
CxUiInputDateControlButtons | Observable<CxUiInputDateControlButtons>
>('Token for providing cwc-input-date [controlButtons] property');

export type CxUiInputDateHideResetButton = CwcInputDate['hideResetButton'];
export const CX_INPUT_DATE_HIDE_RESET_BUTTON_TOKEN = new InjectionToken<
CxUiInputDateHideResetButton | Observable<CxUiInputDateHideResetButton>
>('Token for providing cwc-input-date [hideResetButton] property');

export type cxUiInputDateLabelApply = CwcInputDate['labelApply'];
export const CX_INPUT_DATE_LABEL_APPLY_TOKEN = new InjectionToken<
cxUiInputDateLabelApply | Observable<cxUiInputDateLabelApply>
>('Token for providing cwc-input-date [labelApply] property');

export type cxUiInputDateLabelCancel = CwcInputDate['labelCancel'];
export const CX_INPUT_DATE_LABEL_CANCEL_TOKEN = new InjectionToken<
cxUiInputDateLabelCancel | Observable<cxUiInputDateLabelCancel>
>('Token for providing cwc-input-date [labelCancel] property');
